import { Typography } from '@mui/material';
import React from 'react';
import Image from 'next/image';
import { getModuleDictionary } from '@/shared/i18n';

type ConfirmProps = {
  mailfield: boolean;
  title?: string;
  mail?: string;
  description?: string;
  footer?: React.ReactNode;
  imgSrc?: string;
};

const Confirm = ({ mailfield, title, mail, description, footer, imgSrc }: ConfirmProps) => {
  const [dict, setDict] = React.useState<any>({});

  React.useEffect(() => {
    const loadDict = async () => {
      const locale = 'it';
      const authDict = await getModuleDictionary(locale, 'auth');
      setDict(authDict.auth);
    };
    loadDict();
  }, []);

  const placeholderImage = '/assets/images/placeholder.svg';

  return (
    <section>
      <div className="flex flex-col gap-4">
        <Image
          loading="lazy"
          src={imgSrc || placeholderImage}
          alt="Icon"
          width={56}
          height={56}
          style={{ objectFit: 'contain' }}
          className="self-center"
        />
        <div className="flex flex-col gap-2 w-full text-center">
          <Typography variant="mac-sans-h3" component="h1" color="successLight">
            {title || dict.confirm?.title}
          </Typography>
          {mailfield && (
            <Typography variant="s1" component="p" color="textPrimary">
              {mail}
            </Typography>
          )}
          <Typography variant="body-500" component="p" color="textSecondary">
            {description || dict.confirm?.description}
          </Typography>
        </div>
      </div>
      {footer}
    </section>
  );
};

export default Confirm;
